import script from "./AbnormalGoodsTip.vue?vue&type=script&lang=ts&setup=true"
export * from "./AbnormalGoodsTip.vue?vue&type=script&lang=ts&setup=true"

import "./AbnormalGoodsTip.vue?vue&type=style&index=0&id=3f766a0c&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f766a0c"]])

export default __exports__